<template>
  <section class="points-exchange-page mt-4">
    <app-page-header title="Resgate seus pontos"></app-page-header>
    <div class="boxes-container">
      <div v-if="this.exchange.is_able_mapipay" class="box">
        <div class="box__image">
          <img src="@/assets/img/mapipay1.png" alt="Cartões" />
        </div>
        <div class="box__text">
          <p>
            Troque seus pontos por dinheiro utilizando a conta digital
            <b>MapiPay</b>
          </p>
        </div>
        <div class="box__points">
          <p class="count">{{ points }}</p>
          <p class="title">{{ points == 1 ? 'ponto' : 'pontos' }}</p>
        </div>
        <div class="box__conversion" :class="{ loading: isLoading }">
          <p v-if="!isLoading">Conversão: R$ {{ conversion | number }}</p>
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        </div>
        <div class="box__button">
          <router-link :to="{ name: 'site.points-exchange.mapipay' }">
            <button type="button">RESGATAR CONTA</button>
          </router-link>
        </div>
      </div>
      <div v-if="this.exchange.is_able_mapiflex" class="box">
        <div class="box__image">
          <img src="@/assets/img/cards.png" alt="Cartões" />
        </div>
        <div class="box__text">
          <p>
            Troque seus pontos e utilize como saldo livre com o Vale Presente Mapipay
          </p>
        </div>
        <div class="box__points">
          <p class="count">{{ points }}</p>
          <p class="title">{{ points == 1 ? 'ponto' : 'pontos' }}</p>
        </div>
        <div class="box__conversion" :class="{ loading: isLoading }">
          <p v-if="!isLoading">Conversão: R$ {{ conversion | number }}</p>
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        </div>
        <div class="box__button">
          <router-link :to="{ name: 'site.points-exchange.redeem' }">
            <button type="button">RESGATAR VALE PRESENTE</button>
          </router-link>
        </div>
      </div>
      <div v-if="this.exchange.is_able_britz" class="box">
        <div class="box__image">
          <img src="@/assets/img/loja.jpg" alt="Produtos Loja" />
        </div>
        <div class="box__text">
          <p>
            Converta seus pontos em BRITZ e troque por produtos Philco ou
            Britânia.
          </p>
        </div>
        <div class="box__points">
          <p class="count">{{ points }}</p>
          <p class="title">{{ points == 1 ? 'ponto' : 'pontos' }}</p>
        </div>
        <div class="box__conversion" :class="{ loading: isLoading }">
          <p v-if="!isLoading">
            Conversão em BRITZ: BZ {{ britzConversion | number }}
          </p>
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        </div>
        <div class="box__button">
          <router-link :to="{ name: 'site.points-exchange.trade' }">
            <button type="button">RESGATAR PRODUTO</button>
          </router-link>
        </div>
      </div>
    </div>

    <b-notification type="is-secondary" aria-close-label="Fechar notificação">
      Os pontos convertidos para conta MapiPay, Vale Presente ou para Britz não podem mais retornar para o saldo do Clube após resgatados!
    </b-notification>
  </section>
</template>

<script>
import ExchangeService from '@/services/exchange.service';

export default {
  name: 'points-exchange-page',
  data: () => {
    return {
      exchange: null,
      isLoading: true,
   };
  },
  computed: {
    points() {
      return this.$store.getters.userPoints;
    },
    conversion() {
      return this.exchange ? this.exchange.value * this.points : 0;
    },
    britzConversion() {
      return this.exchange ? this.exchange.value_store * this.points : 0;
    },
  },
  methods: {
    loadExchanges() {
      ExchangeService.get()
        .then(({ data: exchange }) => (this.exchange = exchange))
        .finally(() => setTimeout(() => (this.isLoading = false), 500));
    },
  },
  mounted() {
    this.loadExchanges();
  },
};
</script>

<style lang="scss" scoped>
section.points-exchange-page {
  .boxes-container {
    display: flex;
    justify-content: center;
    margin: 0 15vh;

    .box {
      &:first-child {
        margin-right: 16px;
      }

      &:last-child {
        margin-left: 16px;
      }
    }
  }

  .notification {
    margin: 32px auto;
    max-width: 800px;
  }

  .box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid var(--color-secondary);
    box-shadow: none;
    max-width: 350px;
    margin-bottom: 0;

    &__image {
      max-height: 320px;
    }

    &__text {
      p {
        font-weight: bold;
        font-size: 1.1em;
        font-family: var(--font-family-secondary);
        text-align: center;
        color: var(--text-color-light);
      }
    }

    &__points {
      text-align: center;
      font-family: var(--font-family-secondary);
      margin-top: 16px;

      .count {
        font-size: 1.6em;
        font-weight: bold;
        color: var(--color-primary);
      }

      .title {
        color: var(--color-primary);
        font-size: 1em;
        text-transform: lowercase;
      }
    }

    &__conversion {
      position: relative;
      margin-top: 16px;

      &.loading {
        height: 3em;
      }

      p {
        text-align: center;
        font-weight: bold;
        color: var(--text-color-light);
      }
    }

    &__button {
      text-align: center;
      margin: 16px 0;

      button {
        color: #fff;
        background: var(--color-secondary);
        border: none;
        border-radius: 6px;
        padding: 16px 32px;
        font-size: 1.2em;
        cursor: pointer;
        transition: 0.2s ease-in-out;

        &:hover {
          background: var(--color-secondary-shade);
        }
      }
    }

    &__link {
      text-align: center;
    }
  }
}

@media (max-width: 992px) {
  section.points-exchange-page {
    .boxes-container {
      flex-direction: column;
      margin: 0;
      padding: 0 1em;

      .box {
        &:first-child {
          margin: 0;
          margin-bottom: 1em;
        }

        &:last-child {
          margin: 0;
        }
      }
    }
  }
}
</style>
